import { flow } from 'lodash';
import ClickAndReveal from './ClickAndReveal';
import withUserInput from '../../hocs/UserInput';
import withPager from '../../hocs/Pager';
export default flow(
  withUserInput,
  withPager
)(ClickAndReveal);



// WEBPACK FOOTER //
// ../core/src/components/ClickAndReveal/index.js